// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as NextImage$PorterinFeature from "../../../../../ui/components/NextImage.mjs";
import * as SignupReqSelectionCardModuleScss from "../../styles/SignupReqSelectionCard.module.scss";

var styles = SignupReqSelectionCardModuleScss;

function ResendOtpSelectionCardCmp(Props) {
  var card_data = Props.card_data;
  var option = Props.option;
  var set_option = Props.set_option;
  return React.createElement("div", {
              className: (
                option !== undefined ? option === card_data.option : false
              ) ? "" + styles["requirement-card-wrapper"] + " " + styles.selected + "" : styles["requirement-card-wrapper"],
              onClick: (function (param) {
                  Curry._1(set_option, (function (param) {
                          return card_data.option;
                        }));
                })
            }, React.createElement("div", {
                  className: styles["requirement-card"]
                }, React.createElement("div", {
                      className: styles["image-wrapper"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: card_data.icon.src,
                          height: card_data.icon.height,
                          width: card_data.icon.width,
                          quality: 75.0,
                          alt: card_data.icon.alt
                        })), React.createElement("div", {
                      className: styles["text-wrapper"]
                    }, React.createElement("p", {
                          className: styles.heading
                        }, card_data.heading), React.createElement("p", {
                          className: styles["sub-heading"]
                        }, card_data.sub_heading))), React.createElement("div", {
                  className: styles["checkbox-wrapper"]
                }, React.createElement("input", {
                      className: styles.checkbox,
                      autoFocus: true,
                      checked: option !== undefined ? option === card_data.option : false,
                      type: "radio"
                    })));
}

var make = ResendOtpSelectionCardCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
